import { ReportFAQReqRes } from 'src/app/shared/models/reportFAQReqRes.model';

export class CreateEditFaqDialogContext {
  public reportFaq: ReportFAQReqRes;
  public isEditMode = false;
}
